import React from "react";
import environments from "../../../environments";
import { JacarezinhoBci } from "./providers/jacarezinho";
import { JaguariaivaBci } from "./providers/jaguariaiva";

import { StandardBci } from "./providers/standard";
import { FaxinalBci } from "./providers/faxinal";
import { OrtigueiraBci } from "./providers/ortigueira";

export const Bci: React.FC = () => {
    switch (environments.client.name) {
        case "jgv":
            return <JaguariaivaBci />;
        case "jcz":
            return <JacarezinhoBci />;
        case "faxinal":
            return <FaxinalBci />;
        case "ortigueira":
            return <OrtigueiraBci />;
        default:
            return <StandardBci />;
    }
};
